import { createReducer, on } from '@ngrx/store';
import { setFilterValue } from './pagelevel-filter.actions';
import {
  PagelevelFilterState,
  initialPagelevelFilterState,
} from './pagelevel-filter.state';

export const pagelevelFilterReducer = createReducer(
  initialPagelevelFilterState,
  on(setFilterValue, (state, { filterId, value }): PagelevelFilterState => ({
    ...state,
    [filterId]: value,
  }))
);
